import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const BreadCrumbItem = ({ title, url }) => {
    return (
        <Link className="ml-link breadcrumb-item" to={url}>
            { title }
        </Link>
    );
};

BreadCrumbItem.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
};

export default BreadCrumbItem;
